import {
  BarsOutlined,
  DashboardOutlined,
  HomeOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import DashboardPage from "pages/DashboardPage";

import ErrorListPage from "pages/ErrorListPage";
import HomePage from "pages/HomePage";
import ItemDetailsPage from "pages/ItemDetailsPage";
import ItemListPage from "pages/ItemListPage";

const getNavMenuItems = () => {
  return navs.map((nav) => ({
    key: nav.path ?? nav.name,
    label: nav.name,
    icon: nav.icon,
    children: nav.children?.map((child) => ({
      key: child.path,
      label: child.name,
    })),
  }));
};

const getNavPathToTitlesMap = () => {
  const result = {};
  const traverse = (nav, parentTitles = []) => {
    if (nav.children) {
      nav.children.forEach((child) => {
        traverse(child, [...parentTitles, nav.name]);
      });
    } else {
      result[nav.path] = [...parentTitles, nav.name];
    }
  };
  navs.forEach((nav) => {
    traverse(nav);
  });
  return result;
};

const getNavRoutes = () => {
  const result = [];
  const traverse = (nav) => {
    if (nav.children) {
      nav.children.forEach((child) => {
        traverse(child);
      });
    } else {
      result.push({
        name: nav.name,
        path: nav.path,
        element: nav.element,
      });
    }
  };
  navs.forEach((nav) => {
    traverse(nav);
  });
  return result;
};

const initNav = (name, path, element, icon = null, children = null) => {
  return {
    name,
    path,
    element,
    icon,
    children,
  };
};

const navs = [
  initNav("Home", "/home", <HomePage />, <HomeOutlined />),
  // initNav("Dashboard", "/dashboard", <DashboardPage />, <DashboardOutlined />),
  initNav("Items", null, null, <BarsOutlined />, [
    initNav("Item List", "/items/list", <ItemListPage />),
    initNav("Item Details", "/items/details", <ItemDetailsPage />),
  ]),
  initNav("Errors", "/errors", <ErrorListPage />, <WarningOutlined />),
];
export const navMenuItems = getNavMenuItems(navs);
export const navPathToTitlesMap = getNavPathToTitlesMap(navs);
export const navRoutes = getNavRoutes(navs);
